import * as types from '../constants/ActionTypes';

export const setWaveformLayout = (layout) => ({
  layout,
  type: types.SET_WAVEFORM_LAYOUT,
});

export const setWaveformViewIndex = (index) => ({
  index,
  type: types.SET_WAVEFORM_VIEW_INDEX,
});

export const setWaveformHtmlElement = (index, element) => ({
  index,
  element,
  type: types.SET_WAVEFORM_HTML_ELEMENT,
});

export const setWaveformScaleFactor = (scaleFactor) => ({
  scaleFactor,
  type: types.SET_WAVEFORM_SCALE_FACTOR,
});

export const setWaveformTimeFactor = (timeFactor) => ({
  timeFactor,
  type: types.SET_WAVEFORM_TIME_FACTOR,
});
